import { List } from 'immutable';
import _ from "lodash";

import { NotFoundError } from '../lib/APIClient';
import { resolveAll, resolve } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import Photocard from '../records/Photocard';

const handlePhotocardResponse = photocard => ({
    id: photocard.id,
    title: _.get(photocard, 'cardHolder.title'),
    firstName: _.get(photocard, 'cardHolder.firstName'),
    lastName: _.get(photocard, 'cardHolder.lastName'),
    isOver16: _.get(photocard, 'cardHolder.isOver16'),
    yearOfBirth: _.get(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[0],
    monthOfBirth: _.get(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[1],
    dayOfBirth: _.get(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[2],
    addressLine1: _.get(photocard, 'cardHolder.address.line1'),
    addressLine2: _.get(photocard, 'cardHolder.address.line2'),
    addressLine3: _.get(photocard, 'cardHolder.address.line3'),
    townCity: _.get(photocard, 'cardHolder.address.town'),
    country: _.get(photocard, 'cardHolder.address.country'),
    postcode: _.get(photocard, 'cardHolder.address.postCode'),
    number: photocard.number,
    nickname: photocard.nickname,
});

const PhotocardService = {

    getBaseUrl(user) {
        return `/customers/${user.id}`;
    },

    async getAll (user) {
        try {
            const endpoint = `${this.getBaseUrl(user)}/photocards/all`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            const photocards = response.result.map(photocard => handlePhotocardResponse(photocard));
            return resolveAll(photocards).as(Photocard);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return new List();
        }
    },

    async getByNumber(user, number) {
        try {
            const endpoint = `${this.getBaseUrl(user)}/photocard/number/${number}`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            const photocard = handlePhotocardResponse(response.result);
            return resolve(photocard).as(Photocard);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return null;
        }
    },

    async updateSTicketCard(user, photocard) {
        const endpoint = `${this.getBaseUrl(user)}/photocard/number/sticket/${photocard.number}`;
        return AuthenticatedAPIClient.patch(endpoint, photocard);
    },

    async create(user, photocard) {
        const endpoint = `${this.getBaseUrl(user)}/photocard`;
        const response = await AuthenticatedAPIClient.post(endpoint, photocard.toJS());
        return resolve(response.result).as(Photocard);
    },

    async delete(user, photocard) {
        const endpoint = `${this.getBaseUrl(user)}/photocard/${photocard.id}`;
        await AuthenticatedAPIClient.delete(endpoint);
        return true;
    }

};


export default PhotocardService;
